import { PencilSquareIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";
import AppButton from "../../../ui/buttons/AppButton";
import type { ItemAtVersion } from "../../threads/prepare";

interface EditItemButtonProps {
  item: ItemAtVersion;
  /** The name the card shows, for the accessible name "Edit ‹name›". */
  title: string;
  /** Opens the edit Thread on the item (F51, F36, ADR-0031 D2), never a modal. */
  onEdit: (item: ItemAtVersion) => void;
  /** The graph's card: an icon in its header, kept out of the canvas's drag and pan. */
  compact?: boolean;
}

/** Edit on any card, in the Workflow graph and in a step's input cards alike (F51, F61). */
export default function EditItemButton({ item, title, onEdit, compact = false }: EditItemButtonProps) {
  const { t } = useTranslation();
  const label = t("workflows.details.editNamed", { name: title });
  if (compact) {
    return (
      <button type="button" className="app-flow-chevron app-flow-edit nodrag nopan relative z-10 shrink-0" aria-label={label} title={label} onClick={() => { onEdit(item); }}>
        <PencilSquareIcon className="size-3.5" aria-hidden="true" />
      </button>
    );
  }
  return (
    <AppButton variant="ghost" size="xs" className="ml-auto" aria-label={label} onClick={() => { onEdit(item); }}>
      {t("workflows.inputCard.edit")}
    </AppButton>
  );
}
